const BASE_URL = 'https://flyinapi.dev-sh.xyz/api';
export default BASE_URL;